import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import debounce from 'lodash.debounce';
import {
    Header,
    ClinicList,
    Search,
    Spinner,
    Pagination,
    Row,
} from '../../components';
import { http } from '../../helpers';
import './styles.scss';

const getInitialPagination = () => ({
    number: 0,
    totalPages: 0,
    first: null,
    last: null,
});

export default function Clinics() {
    const navigate = useNavigate();
    const [clinics, setClinics] = useState(null);
    const [pagination, setPagination] = useState(getInitialPagination());
    const [fetching, setFetching] = useState(false);
    const [search, setSearch] = useState('');

    const getClinics = (pageNum = 0, searchStr = search) => {
        const relativeUrl = `/case-api/clinics?size=10&page=${pageNum || 0}&sort=name,id&search=${searchStr || ''}&archived=false`;
        setFetching(true);
        http.get(relativeUrl)
            .then(({ data }) => {
                setClinics(data.content);
                setPagination({
                    number: data.number,
                    totalPages: data.totalPages,
                    first: data.first,
                    last: data.last,
                });
            })
            .catch((error) => {
                console.warn(error);
            })
            .finally(() => setFetching(false));
    };

    useEffect(() => {
        getClinics(0, search);
    }, []);

    const onUpdateSearch = debounce((searchStr) => {
        setSearch(searchStr);
        getClinics(0, searchStr);
    }, 500);
    const onAddClinic = () => {
        navigate('/create-clinic');
    };
    const onChangePage = (page) => {
        getClinics(page, search);
    };
    const onDeleteClinic = (id) => {
        http.delete(`/case-api/clinics/${id}`)
            .then((res) => {
                if (res.status === 200) {
                    getClinics();
                }
            })
            .catch((error) => {
                console.warn(error);
            });
    };
    const onSaveClinic = (clinicToSave) => {
        http.put(`/case-api/clinics/${clinicToSave.id}`, clinicToSave)
            .then((res) => {
                if (res.status === 200) {
                    getClinics();
                }
            })
            .catch((error) => {
                console.warn(error);
            });
    };

    return (
        <>
            <Header label="Clinics" />
            <main className="dashboard-container">
                <Row>
                    <div className="clinic-header">
                        <Search onChange={onUpdateSearch} label="Search clinic name" />
                        <i title="Add new clinic" role="presentation" className="material-icons fz-50 clickable" onClick={onAddClinic}>add_circle</i>
                    </div>
                </Row>
                {
                    fetching && <Spinner type="page" />
                }
                {
                    clinics && !clinics.length && !fetching
                        ? <p className="text-red text-align-center">No clinics found</p>
                        : (
                            <ClinicList
                                clinics={clinics}
                                onDeleteClinic={onDeleteClinic}
                                onSaveClinic={onSaveClinic}
                            />
                        )
                }
                <Pagination onChangePage={onChangePage} pagination={pagination} />
            </main>
        </>
    );
}
